import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/inventoryManage',
  name: 'InventoryManage',
  identify: 'inventoryManage',
  component: LAYOUT,
  redirect: '/inventoryManage/inventoryList',
  meta: {
    icon: 'material-symbols:inventory-2-outline',
    title: '库存管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'inventoryList',
      name: 'InventoryList',
      identify: 'inventoryList',
      component: () => import('@/views/inventoryManage/inventoryList/index.vue'),
      meta: {
        title: '库存查询',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'snDetails',
      name: 'SnDetails',
      identify: 'snDetails',
      component: () => import('@/views/inventoryManage/snDetails/index.vue'),
      meta: {
        title: 'SN单据明细',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'snList',
      name: 'SnList',
      identify: 'snList',
      component: () => import('@/views/inventoryManage/snList/index.vue'),
      meta: {
        title: 'SN激活信息',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'snList/detail',
      name: 'SnListDetail',
      identify: 'snList',
      component: () => import('@/views/inventoryManage/snList/detail.vue'),
      meta: {
        title: 'SN列表详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/inventoryManage/snList',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takePlan',
      name: 'TakePlan',
      identify: 'takePlan',
      component: () => import('@/views/inventoryManage/takePlan/index.vue'),
      meta: {
        title: '盘点计划',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takePlan/add',
      name: 'takePlanAdd',
      identify: 'takePlan',
      component: () => import('@/views/inventoryManage/takePlan/add.vue'),
      meta: {
        title: '新建盘点计划',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/inventoryManage/takePlan',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takePlan/edit',
      name: 'takePlanEdit',
      identify: 'takePlan',
      component: () => import('@/views/inventoryManage/takePlan/edit.vue'),
      meta: {
        title: '编辑盘点计划',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/inventoryManage/takePlan',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takePlan/detail',
      name: 'takePlanDetail',
      identify: 'takePlan',
      component: () => import('@/views/inventoryManage/takePlan/details.vue'),
      meta: {
        title: '查看盘点计划',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/inventoryManage/takePlan',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takeStock',
      name: 'TakeStock',
      identify: 'takeStock',
      component: () => import('@/views/inventoryManage/takeStock/index.vue'),
      meta: {
        title: '库存盘点',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'takeStock/add',
      name: 'takeStockAdd',
      identify: 'takeStock',
      component: () => import('@/views/inventoryManage/takeStock/add.vue'),
      meta: {
        title: '新建盘点任务',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/inventoryManage/takeStock',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'inventoryDiscrepancy',
      name: 'InventoryDiscrepancy',
      identify: 'inventoryDiscrepancy',
      component: () => import('@/views/inventoryManage/inventoryDiscrepancy/index.vue'),
      meta: {
        title: '盘点差异',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
